const middleware = {}

middleware['isAuth'] = require('../middleware/isAuth.js')
middleware['isAuth'] = middleware['isAuth'].default || middleware['isAuth']

middleware['system'] = require('../middleware/system.js')
middleware['system'] = middleware['system'].default || middleware['system']

export default middleware
